import {
    Avatar,
    Box,
    Divider,
    Grid,
    Modal,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import API from "../../util/api";
import { useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Modalcloseicon } from "../../assets/svgicons";
import { formatDistanceToNow } from "date-fns";

const getNotifications = async (token, signal) => {
    return await API.get("/api/notifications", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal
    });
};

export const NotificationDialog = ({ open, onClose, notificationData}) => {

    const token = useSelector((state) => state.auth.authToken);

    const style = {
    position: "absolute",
    left: "50%",
    transform: "translate(-50%, 50px)",
    width: "80%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
  };

    const queryClient = useQueryClient();
    const handleClose = () => {
        onClose()
    };

    // const { data, isFetching } = useQuery(
    //     "notifications",
    //     ({ signal }) => getNotifications(token, signal),
    //     {
    //         enabled: open,
    //         refetchOnWindowFocus: false,
    //         staleTime: 5 * 60 * 1000,
    //         cacheTime: 30 * 60 * 1000, // Keep in cache for 30 min even after modal closes
    //     }
    // );

    useEffect(() => {
        if (!open) {
            queryClient.cancelQueries(['notifications']);
        }
    }, [open, queryClient]);

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style} className="taskmodal">
                <Box className={"pointer pull-right"} onClick={() => handleClose()}>
                    <Modalcloseicon width={18} />
                </Box>

                <p className="title">All notifications</p>
                <Divider sx={{ mt: 1, mb: 1 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <TableContainer
                            component={Paper}
                            sx={{
                                border: "1px solid #4D556533",
                                borderLeft: "0.5px solid #4D556533",
                                borderRadius: 0,
                                "& .MuiTableCell-head": {
                                    // fontSize: 11,
                                    color: "#4D5565 !important",
                                },
                                "& .MuiTableCell-root": {
                                    fontSize: 11,
                                    color: "#4D5565CC",
                                    borderLeft: "1px solid rgba(224, 224, 224, 1)",
                                },
                                maxHeight: "70vh",
                                overflowY: "auto",
                            }}
                            elevation={0}
                        >
                            <Table
                                stickyHeader
                                size="small"
                                aria-label="caption table"
                                sx={{ minWidth: 750 }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">
                                            <h6 style={{ marginBottom: 0, fontSize: 12 }}>
                                                Message
                                            </h6>
                                        </TableCell>

                                        <TableCell align="center">
                                            <h6 style={{ marginBottom: 0, fontSize: 12 }}>
                                                Time
                                            </h6>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {notificationData?.map((notification) => (
                                        <TableRow key={notification.id}>
                                            <TableCell align="left">
                                                <Typography
                                                    fontSize={12}
                                                    display="flex"
                                                    alignItems="center"
                                                    color="#4D5565CC"
                                                >
                                                    {notification.data.message}
                                                </Typography>
                                            </TableCell>

                                            <TableCell align="center">
                                                <Typography fontSize={12} color="#4D5565CC">
                                                    {formatDistanceToNow(new Date(notification.created_at), {
                                                        addSuffix: true,
                                                      })}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                    {(!notificationData || notificationData?.length === 0) && (
                                        <TableRow>
                                            <TableCell colSpan={2} align="center">
                                                <Typography fontSize={12} color="#4D5565CC">
                                                    No notifications
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>

                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
};
